import UserListPage from "../../component/users/dynamic-users/UserList"

 
function UserList() {
  return (
    <div className="page-body"><UserListPage/></div>
  )
}

export default UserList